import React from 'react';
import EditorBold from '@wix/da-ds/pkg/Icons/24x24/EditorBold';
import { ButtonProps } from './types';
import { isExtensionInstalled } from '../../utils/tiptap';
import { useTranslation } from 'react-i18next';
import { TOOLTIP_HOVER_DELAY } from '../../../constants';
import EditorIconButton from '../_partials/EditorIconButton';

const Bold: React.FC<ButtonProps> = ({ editor, hideWhenNotEnabled = true }) => {
  const { t } = useTranslation('editor');
  if (
    !editor.isEditable ||
    (hideWhenNotEnabled && !isExtensionInstalled(editor, 'bold'))
  ) {
    return null;
  }
  return (
    <EditorIconButton
      featureId="format:bold"
      icon={EditorBold}
      onClick={() => editor.chain().focus().toggleBold().run()}
      disabled={!editor.can().chain().focus().toggleBold().run()}
      isActive={editor.isActive('bold')}
      tooltipHoverDelay={TOOLTIP_HOVER_DELAY}
      tooltipText={t('button.bold.tooltip')}
      aria-label={t('button.bold.tooltip')}
    />
  );
};
Bold.displayName = 'Bold';

export default Bold;
